import React from "react";
import '../App.css'

class TextSlider extends React.Component {
    constructor(props) {
        super(props);
        this.isDragging = false;
        this.startX = 0;
        this.startY = 0;
        this.delta = this.props.value;
        this.rate = this.props.rate ? this.props.rate : 0.7;

        this.isClickPossible = true;

        this.childRef = React.createRef();

        this.onUp = this.onUp.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onDown = this.onDown.bind(this);
        this.onClick = this.onClick.bind(this);

    }

    componentDidMount() {
        this.renderText();
    }

    componentDidUpdate() {
        this.delta = this.props.value;
        this.renderText();
    }

    onDown(e) {
        this.isDragging = true;
        e.currentTarget.setPointerCapture(e.pointerId);
        this.startX = e.clientX;
        this.startY = e.clientY;
    };

    onUp(e){
        if(this.isDragging){
            this.isDragging = false;
            this.props.onChange(this.delta);
        }
    }
    onMove(e) {
        if(!this.isDragging)
            return false;
        let d = Math.round(((-1*(this.startX - e.clientX )+ (this.startY - e.clientY)/2)/2) * this.rate);
        this.delta = this.props.value + (d);
        if(this.props.max !== undefined){
            this.delta = Math.min(this.delta,this.props.max);
        }
        if(this.props.min !== undefined){
            this.delta = Math.max(this.delta,this.props.min);
        }
        this.renderText();
        this.isClickPossible = false;
    }

    onClick(e){
        if(this.isClickPossible){
            let newdelta = parseInt(prompt('Enter in the value:',this.delta));
            if(!isNaN(newdelta)){
                this.delta = Math.min(Math.max(newdelta,this.props.min),this.props.max);
                this.props.onChange(this.delta);
            }else{
                this.onClick(e);
            }

        }
        this.isClickPossible = true;
    }

    renderText(){
        this.childRef.current.innerHTML = ' '+this.props.display(this.delta).props.children.join('')+' ';
    }

    render(){

        return (
            <span className="noselect" onDoubleClick={this.onClick} onPointerLeave={this.onUp} onPointerUp={this.onUp} onPointerMove={this.onMove} onPointerDown={this.onDown} style={{textDecoration: "underline dotted ",cursor: "ew-resize"}}><span ref={this.childRef}></span></span>
        );
    }
};



export default TextSlider;
